import React, { useMemo } from "react";
import { useNavigate } from "react-router";
import { SelectionLayoutProps } from "@companion-core/shared/app/Interfaces/blocks";
import { useDynamicPageStore } from "@companion-core/shared/app/Store/dynamicPageStore";
import { MosaicLayout } from "@companion-core/web/src/Components/MosaicLayout";
import { Button } from "@companion-core/shared/app/Components/Button";
import { ComponentCard } from "@companion-core/shared/app/Components/Cards/ComponentCard";
import { SelectionCommonLayout } from "@companion-core/shared/app/Components/Blocks/Layouts/SelectionCommonLayout/SelectionCommonLayout";
import { redirectTo } from "@companion-core/web/src/Utilities/navigation";
import { useMediaQuery } from "@companion-core/web/src/Utilities/mediaQuery";
import "@companion-core/web/src/Assets/Styles/scss/selectionMosaicLayout.scss";

export const SelectionMosaicLayout = ({
  text,
  cardList,
  button,
  blockSlug,
}: SelectionLayoutProps) => {
  const { pageSlug, blocksBySlug } = useDynamicPageStore();
  const colorIndex = useMemo(() => {
    return blocksBySlug[blockSlug ?? ""]?.isLoaded
      ? (blocksBySlug[blockSlug ?? ""].colorIndex ?? 0)
      : 0;
  }, [blocksBySlug, blockSlug]);
  const navigate = useNavigate();
  const isMobileSize = useMediaQuery("(max-width: 768px)");

  return (
    <div className={colorIndex % 2 === 0 ? "colored-background--odd" : "colored-background--even"}>
      {isMobileSize ? (
        <SelectionCommonLayout
          text={text}
          cardList={cardList}
          button={button}
          blockSlug={blockSlug}
        />
      ) : (
        <section className="selection-mosaic-layout" data-testid="selection-mosaic">
          {text && (
            <h2
              data-testid="selection-mosaic__title"
              className="selection-mosaic-layout__title super-title-3">
              {text.title}
            </h2>
          )}
          {text?.subtitle && (
            <span
              data-testid="selection-mosaic__subtitle"
              className="selection-mosaic-layout__subtitle title-8">
              {text.subtitle}
            </span>
          )}
          <MosaicLayout
            data-testid="selection-mosaic__cards"
            items={cardList?.map((component, index) => {
              return (
                <ComponentCard
                  key={`selection-mosaic-layout-discount-${component.id}`}
                  component={component}
                  pageSlug={pageSlug ?? ""}
                  nbItems={cardList.length}
                  position={index}
                  url={window.location.href}
                />
              );
            })}></MosaicLayout>
          {button && button.button_title && (
            <Button
              testID="selection-mosaic__cta"
              label={button.button_title}
              size="large"
              classNames={["selection-mosaic-layout__button"]}
              onClick={() =>
                redirectTo(button.button_link ?? "/", button?.button_type ?? "internal", navigate)
              }
            />
          )}
        </section>
      )}
    </div>
  );
};
